import { TPromotion } from '../../types/config';
import { Box, Stack } from '@mui/material';
import { BoxAbsolute } from './styles';

type Props = {
  data: TPromotion;
  onClick: () => void;
};

export default function MainPromo({ data, onClick }: Props) {
  return (
    <>
      <Stack
        sx={{
          position: 'relative',
          borderRadius: '12px',
          margin: '24px 0',
          alignItems: 'flex-start',
        }}
      >
        <Box
          sx={{
            position: 'relative',
            height: 'auto',
            maxHeight: '500px',
            width: data.bgImage ? 'auto ' : '100%',
            cursor: 'pointer',
          }}
          onClick={onClick}
        >
          {data.bgImage ? (
            <img
              src={data.bgImage}
              style={{
                height: 'auto',
                maxHeight: '500px',
                maxWidth: '100%',
                borderRadius: '12px',
                objectFit: 'contain',
                zIndex: 1,
              }}
              loading="lazy"
              decoding="async"
            />
          ) : (
            <BoxAbsolute
              sx={{
                zIndex: 1,
                backgroundColor: data.bgColor || '#000',
              }}
            />
          )}

          <BoxAbsolute
            sx={{
              zIndex: 2,
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'rgba(0,0,0,0.1)',
              },
            }}
          />

          {/* <BoxAbsolute
          sx={{
            zIndex: 3,
            ...overlayCss(data),
          }}
        /> */}

          {/* <BoxAbsolute
          sx={{
            zIndex: 4,
            padding: '36px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
            alignItems: 'stretch',
            alignContent: 'stretch',
            color: data.textColor,
            overflow: 'hidden',
          }}
        >
          <Stack direction="row" justifyContent="space-between" alignItems="flex-end">
            <Stack direction="column" justifyContent="space-between" alignItems="flex-start" gap="10px" sx={{ paddingInlineEnd: '36px' }}>
              {data.title && (
                <Typography
                  fontSize="34px"
                  lineHeight="40px"
                  fontWeight={600}
                  sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: '-webkit-box',
                    WebkitLineClamp: '2', // Number of lines to show
                    WebkitBoxOrient: 'vertical',
                  }}
                >
                  {string.truncate(data.title, 50)}
                </Typography>
              )}
              {data.description && (
                <Typography
                  fontSize="20px"
                  lineHeight="24px"
                  fontWeight={200}
                  sx={{
                    opacity: 0.8,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: '-webkit-box',
                    WebkitLineClamp: '3', // Number of lines to show
                    WebkitBoxOrient: 'vertical',
                  }}
                >
                  {string.truncate(data.description, 80)}
                </Typography>
              )}
            </Stack>

            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                opacity: '0.7',
                cursor: 'pointer',
                '& svg': {
                  marginInlineStart: '6px',
                  marginInlineEnd: '4px',
                  transition: 'all 0.3s ease-in-out',
                },
                '&:hover': {
                  opacity: '1',
                  '& svg': {
                    marginInlineStart: '10px',
                    marginInlineEnd: '0px',
                  },
                },
              }}
            >
              <Typography sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} onClick={onClick}>
                {string.truncate(data.cta || t('labels.learnMore'), 20)}
              </Typography>

              <Svg
                Icon={direction === 'rtl' ? ChevronLeft : ChevronRight}
                sx={{
                  color: data.textColor,
                }}
              />
            </Stack>
          </Stack>
        </BoxAbsolute> */}
        </Box>
      </Stack>
    </>
  );
}
